// extracted by mini-css-extract-plugin
export default {"ssoSwitchWrapper":"SSOSwitch_ssoSwitchWrapper__qaOw9","switch":"SSOSwitch_switch__TzjED","disabled":"SSOSwitch_disabled__X+gz7"};